// import glo from '../../main'
// import { tkParse } from '@moke/vue-tk'
// import myViewPage from '../component/myViewPage'
export default {
  className: 'order',
  title: '购物订单',
  render: (record) => {
    return record.orderId
  },
  fields: [
    {
      name: 'orderId'
    },
    {
      name: 'user',
      note: '用户',
      searchKey: ['phone', 'nickName'],
      render: (record) => {
        if (record && record.user) {
          return `${record.user.nickName}(${record.user.phone})`
        }
      },
      listWhere: (where) => {
        where.isAdmin = {
          $ne: true
        }
      }
    },
    {
      name: 'paytype',
      width: 120
    },
    {
      name: 'money',
      note: '应付金额',
      width: 120
    },
    {
      name: 'relMoney',
      note: '实付金额',
      width: 120
    },
    {
      name: 'state'
    },
    // {
    //   name: 'isInPlace',
    //   width: 120,
    //   render: (record) => {
    //     return record && record.isInPlace ? '是' : '否'
    //   }
    // },
    {
      name: 'goodsObj',
      note: '商品信息',
      render: (record) => {
        let string = ''
        if (record.goodsObj) {
          for (let i in record.goodsObj) {
            let item = record.goodsObj[i]
            if (Number(i) === record.goodsObj.length - 1) {
              string += `${item.name}(${item.count})`
            } else {
              string += `${item.name}(${item.count})、`
            }
          }
        }
        return string
      }
    },
    'deliveryMode',
    'address',
    {
      name: 'deliveryAddress',
      note: '送货地址',
      render: (record) => {
        if (record && record.deliveryAddress) {
          return decodeURIComponent(record.deliveryAddress)
        }
      }
    },
    {
      name: 'deliveryTime',
      note: '上门时间',
      render: (record) => {
        if (record && record.deliveryTime) {
          return decodeURIComponent(record.deliveryTime)
        }
      }
    }
  ],
  search: [
    'orderId',
    'paytype',
    'deliveryMode',
    'address',
    'user',
    'isInPlace'
  ],
  action: {
    delete: false,
    create: false,
    edit: false
    // view: {
    //   type: 'row',
    //   text: '查看',
    //   component: myViewPage
    // }
    // send: {
    //   type: 'row',
    //   text: '到货',
    //   title: '确认到货',
    //   hidden: ({ record }) => {
    //     return record && (record.isInPlace || record.state === 'completed')
    //   },
    //   callback: async ({ vm, record }) => {
    //     await vm.confirm('警告', '您确定此订单已到货?')
    //     await vm.$tkParse.put(`/classes/order/${record.objectId}`, {
    //       isInPlace: true,
    //       state: 'completed',
    //       goodsInPlaceAt: new Date().toISOString(),
    //       timeDone: new Date().toISOString()
    //     })
    //     try {
    //       vm.$notification['success']({
    //         message: '操作成功'
    //       })
    //       vm.refresh()
    //     } catch (e) {
    //       vm.$notification['error']({
    //         message: '网络错误,请重试'
    //       })
    //     }
    //   }
    // }
  },
  hooks: {
    beforeFetch ({ where }) {
      where.type = 'shopping'
      where.state = {
        $nin: ['bePaid', 'refund']
      }
    }
  }
}
